<template>
  <v-app-bar
    color="#2e70b6"
    dark
    elevation="0"
    app
    fixed
  >
    <v-app-bar-nav-icon @click.stop="handleDrawerToggle" />

    <v-toolbar-title class="app-title">
      Central de Serviços
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
import Vue from "vue";
import GlobalStore from "@/store/modules/global";

export default Vue.extend({
  name: "app-toolbar",
  methods: {
    handleDrawerToggle() {
      GlobalStore.toggleDrawer();
    }
  }
});
</script>

<style scoped>
.app-title {
  font-weight: 400;
  text-align: center;
  margin: auto;
  text-transform: uppercase;
}
</style>
